import styled from "styled-components"
import FadeIn from "react-fade-in"

const ContainerLight = styled.section`
  background-color: ${(props) => props.theme.a_color_gradients.a_light};
  & > div {
    background-color: ${(props) => props.theme.a_color_gradients.a_light};
  }
`
const BorderTaxo = styled.span`
  border: 1px solid ${(props) => props.theme.b_color_gradients.b_dark};
  color: ${(props) =>
    props.activeBool ? props.activeText : props.theme.b_color_gradients.b_dark};
  background-color: ${(props) =>
    props.activeBool ? props.theme.b_color_gradients.b_dark : props.activeText};
  &:hover {
    background-color: ${(props) =>
      props.activeBool ? null : props.theme.b_color_gradients.b_dark};
    color: ${(props) => (props.activeBool ? null : props.activeText)};
  }
`
const EventsItem = styled.div`
  border-bottom: 1px solid ${(props) => props.theme.a_color_gradients.a_light};
  &:hover div:first-of-type::before {
    background-color: ${(props) => props.theme.b_color_gradients.b_dark};
  }
`
const StyledFade = styled(FadeIn)`
  & > div:nth-of-type(1),
  & > div:nth-of-type(3) {
    background-color: ${(props) => props.theme.a_color_gradients.a_light};
  }
`

export { ContainerLight, EventsItem, BorderTaxo, StyledFade }
